import React, { Component } from 'react';
import { Table, Tag, Space, PageHeader, Modal, Button, Input, Popconfirm, Spin, Pagination, Row, Col, Select, Tooltip } from 'antd';
import { Container } from '../../components/layout/style';
import {CheckCircleOutlined, ClearOutlined, DownloadOutlined, EditOutlined, EyeFilled, PlusSquareOutlined, SearchOutlined, StopOutlined} from '@ant-design/icons'
import AddBatch from './addBatch';
import { connect } from 'react-redux';
import {getBatches,fileDownloader} from '../../actions/batch';
import Highlighter from 'react-highlight-words';
import history from '../../history';

const { Option } = Select;


class BatchList extends React.Component {
  state = {
    data: [],
    isModalVisible: false,
    page: 1,
    title: '',
    active: '',
    batch_no: '',
    total: null,
  }
 
  
  data = [
    {
      key: '1',
      name: 'John Brown',
      age: 32,
      address: 'New York No. 1 Lake Park',
      tags: ['nice', 'developer'],
    },
    {
      key: '2',
      name: 'Jim Green',
      age: 42,
      address: 'London No. 1 Lake Park',
      tags: ['loser'],
    },
    {
      key: '3',
      name: 'Joe Black',
      age: 32,
      address: 'Sidney No. 1 Lake Park',
      tags: ['cool', 'teacher'],
    },
  ];
  
  componentDidMount = async () => {
    
    window.scrollTo(0, 0);
    const {page, active,batch_no, title} = this.state
    const res = await this.props.getBatches(page,title,active,batch_no)
    this.setState({data: res.batch,total: res.count})
  }

  // ==============Search operation start============
  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              this.setState({
                searchText: selectedKeys[0],
                searchedColumn: dataIndex,
              });
            }}
          >
            Filter
          </Button>
        </Space>
      </div>
    ),
    filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
        : '',
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: text =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });
  
  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };
  
  handleStatus = async () => {
    // const res = await this.props.updateProductAuth(product,status)
    // if(res === 201){
    //   this.handleRefresh()
    // }
  }

  // =========== Refresh =============
  handleRefresh = async () => {
    const res = await this.props.getBatches(1,'','','')
    this.setState({data: res.batch,total: res.count})
  }

  // ========= Reset Search ==========
  handleReset = clearFilters => {
    clearFilters();
    this.setState({ searchText: '' });
  };
  
  resetSearch = async () => {
    const res = await this.props.getBatches(1,'','','')
    this.setState({data: res.batch,total: res.count, batch_no: '',active: '',batch_no: '', title: ''})
  }

  handleApiSearch = async () => {
    const {batch_no, title, active,page} = this.state
    const res = await this.props.getBatches(page,title,active,batch_no)
    this.setState({data: res.batch,total: res.count})
  }

  createData = (batch_no,product,title,code_count,total_cost,thumbnail,active,payment_status, created_at,file_link,action) => {
    return {batch_no, product,title,code_count,total_cost,thumbnail,active, payment_status, created_at,file_link,action};
  };

  makeLocalTime = (date) => {
    let mainDate = date.split('T')[0];
    let hours = date.split('T')[1].split(':')[0];
    let minutes = date.split('T')[1].split(':')[1];
    var am = true;
    if (hours > 12) {
        am = false;
        hours -= 12
    } else if (hours == 12) {
        am = false;
    } else if (hours == 0) {
        hours = 12
    }
    return mainDate + " , " + hours+":"+minutes + " " + (am ? "a.m" : "p.m")
  }
  render() { 
    
    const columns = [
    
      {
        title: 'Batch No',
        dataIndex: 'batch_no',
        key: 'batch_no',
        ...this.getColumnSearchProps('batch_no'),
      },
      {
        title: 'Product',
        dataIndex: 'product',
        key: 'product',
        ...this.getColumnSearchProps('product'),
      },
      {
        title: 'Title',
        dataIndex: 'title',
        key: 'title',
        ...this.getColumnSearchProps('title')
      },
      {
        title: 'Code Count',
        dataIndex: 'code_count',
        key: 'code_count',
        ...this.getColumnSearchProps('code_count')
      },
      
      {
        title: 'Cost',
        dataIndex: 'total_cost',
        key: 'total_cost',
        ...this.getColumnSearchProps('total_cost')
      },
      
      {
        title: 'Thumbnail',
        dataIndex: 'thumbnail',
        key: 'thumbnail',
        ...this.getColumnSearchProps('thumbnail')
      },
      
      {
        title: 'Status',
        dataIndex: 'active',
        key: 'active',
        ...this.getColumnSearchProps('active')
      },
      {
        title: 'Payment Status',
        dataIndex: 'payment_status',
        key: 'payment_status',
        ...this.getColumnSearchProps('payment_status')
      },
      
      {
        title: 'Created at',
        key: 'created_at',
        ...this.getColumnSearchProps('created_at'),
        dataIndex: 'created_at',
        
      },
      {
        title: 'File',
        key: 'file_link',
        dataIndex: 'file_link',
        
      },
      {
        title: 'Action',
        key: 'action',
        dataIndex: 'action',
      
      },
    ];
    
    const {data,total} = this.state;

    
    const rows = [
      data
        ? data.map((data) => this.createData(
          data.batch_no, 
          data?.product?.name, 
          data.title, 
          data.code_count, 
          data?.total_cost, 
          data?.product?.thumbnail ?
            <img className='thumb' src={`${process.env.REACT_APP_API_BASE_URL}/files/${data?.product?.thumbnail}`} width="50px" alt="" />
            :
            <img className='thumb' src="./demo.jpg" width="50px" alt="" />
          , 
          <>
            {data.active === 'active' ?
              <> 
                <Tag color="#87d068">Active</Tag> 
                {/* <Popconfirm title="Are you sure？" okText="Yes" cancelText="No" onConfirm={() => this.handleStatus(data.product_id, 'inactive')}><Button size="small" type="danger" icon={<StopOutlined  />}>Disable</Button></Popconfirm> */}
              </>: 
              <>
                <Tag color="#f50">Inactive</Tag>
                {/* <Popconfirm title="Are you sure？" okText="Yes" cancelText="No" onConfirm={() => this.handleStatus(data.product_id, 'active')}><Button size="small" type="secondary" icon={<CheckCircleOutlined  />}>Activate</Button></Popconfirm> */}
              </>
            }
          </>,
          <>
            {data.payment_status === 'paid' ?
              <> 
                <Tag color="#87d068">Paid</Tag> 
              </>: 
              <>
                <Tag color="#f50">Unpaid</Tag>
                </>
            }
          </>,
          this.makeLocalTime(data.created_at), 
          data.status == 'processed' ? 
            <Button size="small" type="primary" icon={<DownloadOutlined  />} onClick={() => this.props.fileDownloader(data.batch_id)}>Download</Button> 
              :
            <Button size="small" type="default" icon={<Spin size='small' />} style={{cursor: "not-allowed"}}> &nbsp; Processing</Button>
          ,
          
         
          <>
{/*           
           <Button size="small" type="primary" icon={<EditOutlined  />} onClick={()=> this.setState({product_id: data.product_id, isEditModalVisible: true})}>Edit</Button> &nbsp;
           <Button size="small" type="primary" icon={<EyeFilled  />} onClick={()=> history.push(`/product-details?id=${data.product_id}`)}>View</Button> &nbsp;
           */}
          
           <Button size="small" type="primary" icon={<EyeFilled  />} onClick={() => history.push(`/batch-details?id=${data.batch_id}`) }>View</Button> &nbsp;
          
          </>
          ))
        : "",
    ];

    return (
      <Container style={{minHeight: '100vh'}}>
        <PageHeader
            ghost={false}
            onBack={() => window.history.back()}
            title="Batches"
            subTitle="List of all batches"
            extra={[
                <Button key="1" type="primary" icon={<PlusSquareOutlined />} onClick = { () => this.setState({isModalVisible: true})}>
                    Add Batch
                </Button>,
            ]}
        >
        </PageHeader>
        <br />
            <Row gutter={10}>
                <Col xs={12} sm={12} md={8} lg={8} xl={7}>
                    <Input placeholder="Batch No" allowClear style={{width:'99%', margin: '10px 0px'}} onChange={(e)=>this.setState({batch_no:e.target.value})} />
                </Col>
                <Col xs={12} sm={12} md={8} lg={8} xl={7}>
                    <Input placeholder="Title" allowClear style={{width:'99%', margin: '10px 0px'}} onChange={(e)=>this.setState({title:e.target.value})} />
               
                </Col>
                <Col xs={12} sm={12} md={8} lg={8} xl={7}>
                    <Select
                        showSearch
                        style={{ width: "99%", margin: '10px 0px' }}
                        placeholder="Select a status"
                        name="status"
                        optionFilterProp="children"
                        onChange={(e)=>this.setState({active:e})}
                        filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                    >
                        <Option value="">None</Option>
                        <Option value="active">Active</Option>
                        <Option value="inactive">Inactive</Option>
                    </Select>
                 </Col>
                <br />
                
                <Col xs={12} sm={12} md={6} lg={6} xl={3}  style={{ margin: '10px 0px'}}>
                   &nbsp;&nbsp;&nbsp;&nbsp;
                    <Tooltip title="Search" onClick={this.handleApiSearch}>
                        <Button type="primary" shape="circle" icon={<SearchOutlined />} />
                    </Tooltip>
                   &nbsp;&nbsp;&nbsp;&nbsp;
                    <Tooltip title="Reset" onClick={this.resetSearch}>
                        <Button type="primary" shape="circle" icon={<ClearOutlined />} />
                    </Tooltip>
                </Col>
            </Row>
          <Table  pagination={false} columns={columns}  scroll={{ x: 10, }} dataSource={rows[0]} />
          <br />
          <Pagination defaultCurrent={1} total={total}  pageSize={20} style={{textAlign: 'right', paddingRight: '100px'}} onChange={(page) => this.handleRefresh(page)} />
          
          <Modal okButtonProps={{ style: { display: 'none' } }} okText="Close" width="90%" title="Add A New Batch" visible={this.state.isModalVisible} onCancel={()=>this.setState({isModalVisible: false}) }>
              <AddBatch fnc = {() => this.setState({isModalVisible: false}) } refresh = {this.handleRefresh} />
          </Modal>
      </Container>
    );
  }
}
 
export default connect(null,{getBatches,fileDownloader})(BatchList);